import script from "./diningRecords.vue?vue&type=script&setup=true&lang=js"
export * from "./diningRecords.vue?vue&type=script&setup=true&lang=js"

import "./diningRecords.vue?vue&type=style&index=0&id=3ada1088&lang=scss"

const __exports__ = script;

export default __exports__